import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// State
import { stockSelector } from '../../state/modules/stock/selectors';

const DesktopView = loadable(() => import('./DesktopView'));
const MobileView = loadable(() => import('./MobileView'));

export default function StockListPage() {
  const intl = useIntl();
  const { alias } = useParams();
  const { name, declension } = useSelector(state => state.city.userCity);
  const { title } = useSelector(state => stockSelector(state, alias));

  const isRealPhone = useSelector(state => state.responsive.isRealPhone);

  const View = isRealPhone ? MobileView : DesktopView;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: 'page.stocklist.helmet' }, { title, declension, name })}
        </title>
        <meta
          name="description"
          content={intl.formatMessage(
            { id: 'page.stocklist.helmet.description' },
            { declension, name },
          )}
        />
      </Helmet>
      <View />
    </>
  );
}
